module.exports = __webpack_public_path__ + "img/Ivory Coast.4c54d915.svg";